import { DarwinFlex, DarwinImage } from 'components/darwin-ui';
import { UserByWallet, UserCompanyList } from 'types/userTypes';
import styles from './header.module.css';
import { UserConfiguration } from './UserConfiguration';

interface AppHeaderProps {
  handleDisconnect: () => void;
  companies: UserCompanyList;
  userData?: UserByWallet | undefined;
}

export const AppHeader = ({
  handleDisconnect,
  companies,
  userData,
}: AppHeaderProps) => {
  return (
    <header className={styles.mainHeader}>
      <DarwinFlex
        justify="space-between"
        align="center"
        className={styles.userManagementContainer}
      >
        <DarwinImage width={112} preview={false} src="/darwin_logo.png" />

        <UserConfiguration
          companies={companies}
          handleDisconnect={handleDisconnect}
          userData={userData}
        />
      </DarwinFlex>
    </header>
  );
};
